import {
  skipToken,
  useQuery,
  type QueryFunctionContext,
} from '@tanstack/react-query';
import { useCurrentSimDataId } from '../SimViewer/useCurrentSimDataId';
import { dataApiClient } from '../../infrastructure/dataApi/client';
import { useMetaData } from './useMetaData';
import { useApiDataFilter } from '../SimViewer/useApiDataFilter';

type UseSummaryData = {
  isLoading: boolean;
  agentCount: number | null;
};

const useSummaryData = (): UseSummaryData => {
  const { currentSimDataId } = useCurrentSimDataId();
  const { currentDataMeta } = useMetaData();
  const { apiFilter } = useApiDataFilter();

  const viewMagnification = 1 / Number(currentDataMeta?.reduction_factor ?? 1);

  const { data, isFetching } = useQuery({
    queryKey: ['summary', currentSimDataId, apiFilter],
    queryFn: currentSimDataId
      ? async ({ signal }: QueryFunctionContext): Promise<number> => {
          return dataApiClient.getSummary(currentSimDataId, apiFilter, signal);
        }
      : skipToken,
    meta: { dataType: 'others' },
  });

  return {
    isLoading: isFetching,
    agentCount:
      data !== undefined ? Math.floor(data * viewMagnification) : null,
  };
};

export { useSummaryData };
